import { mapGetters } from 'vuex';
import { BILLING_CYCLE } from '@/common/constants';
import { capitalizeFirstLetter } from '@/common/utils';
import { upperFirst } from 'lodash';
export default {
  computed: {
    ...mapGetters(['getSelectedPlans', 'boughtPlans']),
    mx_licenseTips() {
      return this.$t('billing.events.saas.capacityTips', [this.title]);
    },
    mx_textViewModel() {
      return this.inVisibleCapacityList.length === 0;
    }
  },
  methods: {
    mx_getCurrentCapacityGroupOptions(options) {
      const group = {};
      const cycleLabelMap = {
        [BILLING_CYCLE.MONTHLY]: `${this.$t('billing.billing_cycle.monthly')} ${this.$t('billing.billing_cycle.subscription')}`,
        [BILLING_CYCLE.ANNUAL]: `${capitalizeFirstLetter(this.$t('billing.billing_cycle.annual'))} ${this.$t('billing.billing_cycle.subscription')}`,
      }
      options.forEach(capacity => {
        const cycleOption = this.capacityMap?.[capacity];
        if(cycleOption) {
          cycleOption.forEach(plan => {
            if (group[plan.billing_cycle]) {
              group[plan.billing_cycle].push(plan);
            } else {
              group[plan.billing_cycle] = [plan];
            }
          })
        }
      });
      const groups = Object.keys(group).reduce((prev, cycle) => {
        const cur = group[cycle];
        const label = cycleLabelMap[cycle];
        prev.push({
          label,
          cycle: cycle,
          options: cur.map(p => p.capacity).map(c => {
            const _options = this.mx_getBillingCycleList(c);
            if (_options.length) {
              const plan =  _options.find(p => p.plan.billing_cycle === cycle) ?? {};
              const hasBought = this.boughtPlans.find(p => p.plan_code === plan?.plan?.plan_code);
              if (hasBought || !plan.disabled) {
                return {
                  capacity: plan.plan.capacity,
                }
              }
            }
            return null;
          }).filter(p => p)
        });
        return prev;
      }, []);
      return groups;
    },
    mx_getBillingCycleGroupOptions(_, capacity) {
      const isCurrentSelectedCapacityPlan = this.selectedPlanList.find(p => p.capacity === capacity);
      const categorizedPlanByCycle = this.getCategorizedPlanByCycle(capacity);
      const options = categorizedPlanByCycle.map(p => {
        const sortOptions = p.options.sort((a,b) => a.capacity - b.capacity);
        const maxCapacity = sortOptions[sortOptions.length - 1]?.capacity;
        const minCapacity = sortOptions[0]?.capacity || 100;
        const label = maxCapacity > minCapacity ? this.$t('billing.single_use_meeting.a_to_b_attendees', [minCapacity, maxCapacity]) : `${minCapacity} ${upperFirst(this.$t('billing.attendees'))}`;
        const availableSortOptions = sortOptions.filter(plan => {
          const option = this.mx_getBillingCycleList(plan.capacity).find(({ plan }) => plan.billing_cycle === p.cycle);
          const hasBought = this.boughtPlans.find(p => p.plan_code === option.plan.plan_code);
          if (!hasBought && option.disabled) return false;
          const hasSelected = this.selectedPlanList.find(p => plan.plan_code === p.plan_code);
          return !hasSelected;
        });
        let availableOption = null;
        if (isCurrentSelectedCapacityPlan && isCurrentSelectedCapacityPlan.billing_cycle === p.cycle && sortOptions.find(o => o.capacity === capacity)) {
          availableOption = this.mx_getBillingCycleList(capacity);
        } else if (availableSortOptions.length) {
          availableOption = this.mx_getBillingCycleList(availableSortOptions[0]?.capacity);
        }
        if (availableOption?.length) {
          availableOption = availableOption
            .map(plan => {
              const hasBought = this.boughtPlans.find(p => p.plan_code === plan.plan.plan_code);
              if (hasBought) {
                return {
                  ...plan,
                  disabled: false,
                  tooltips: '',
                  alert: ''
                }
              }
              return plan;
            })
            .filter(plan => {
              const hasBought = this.boughtPlans.find(p => p.plan_code === plan.plan.plan_code);
              if (hasBought) {
                return plan.plan.billing_cycle === p.cycle;
              }
              return plan.plan.billing_cycle === p.cycle && !plan.disabled;
            });
        }
        return {
          label,
          options: availableOption?.length ? availableOption : [],
          cycle: p.cycle,
        }
      });
      return options;
    },
    getCategorizedPlanByCycle(capacity) {
      const availablePlanList = this.planList.filter(p => {
        const isSelected = this.selectedPlanList.find(plan => p.capacity == plan.capacity && capacity !== plan.capacity);
        return !isSelected;
      });
      const categorizedPlanByCycle = availablePlanList.reduce((prev, cur) => {
        const target = prev.find(p => p.cycle === cur.billing_cycle);
        if (target) {
          target.options.push(cur);
        } else {
          prev.push({
            cycle: cur.billing_cycle,
            options: [cur]
          })
        }
        return prev;
      }, []);
      return categorizedPlanByCycle;
    },
    async beforeSwitchCapacityHook(oldSelectedPlan, newPlanInfo) {
      const hasBought = this.boughtPlans.find(p => p.plan_code === newPlanInfo?.plan_code);
      if (hasBought) {
        return hasBought.cartInfo;
      }
      return oldSelectedPlan.cartInfo;
    }
  }
}
